var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_18)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_18",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 0.5H0.5V32.5H38.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 6.33331C36.4673 6.33383 36.9167 6.51276 37.2565 6.83354C37.5963 7.15432 37.8008 7.59273 37.8282 8.05921C37.8555 8.52568 37.7038 8.98501 37.4039 9.34334C37.1039 9.70167 36.6785 9.93195 36.2145 9.98714L36 9.99998V28.3333C36.4673 28.3338 36.9167 28.5128 37.2565 28.8335C37.5963 29.1543 37.8008 29.5927 37.8282 30.0592C37.8555 30.5257 37.7038 30.985 37.4039 31.3434C37.1039 31.7017 36.6785 31.932 36.2145 31.9872L36 32H3C2.53272 31.9995 2.08328 31.8205 1.74349 31.4998C1.40371 31.179 1.19924 30.7406 1.17185 30.2741C1.14447 29.8076 1.29624 29.3483 1.59616 28.99C1.89607 28.6316 2.32149 28.4014 2.7855 28.3462L3 28.3333V9.99998C2.53272 9.99947 2.08328 9.82053 1.74349 9.49975C1.40371 9.17898 1.19924 8.74057 1.17185 8.27409C1.14447 7.80762 1.29624 7.34828 1.59616 6.98995C1.89607 6.63162 2.32149 6.40133 2.7855 6.34614L3 6.33331H36ZM32.3333 9.99998H6.66667V28.3333H10.3333V15.5C10.3333 15.0138 10.5265 14.5474 10.8703 14.2036C11.2141 13.8598 11.6804 13.6667 12.1667 13.6667C12.6529 13.6667 13.1192 13.8598 13.463 14.2036C13.8068 14.5474 14 15.0138 14 15.5V28.3333H17.6667V15.5C17.6667 15.0138 17.8598 14.5474 18.2036 14.2036C18.5475 13.8598 19.0138 13.6667 19.5 13.6667C19.9862 13.6667 20.4525 13.8598 20.7964 14.2036C21.1402 14.5474 21.3333 15.0138 21.3333 15.5V28.3333H25V15.5C25 15.0138 25.1932 14.5474 25.537 14.2036C25.8808 13.8598 26.3471 13.6667 26.8333 13.6667C27.3196 13.6667 27.7859 13.8598 28.1297 14.2036C28.4735 14.5474 28.6667 15.0138 28.6667 15.5V28.3333H32.3333V9.99998ZM30.5 0.833313C30.9862 0.833313 31.4526 1.02647 31.7964 1.37028C32.1402 1.7141 32.3333 2.18042 32.3333 2.66665C32.3333 3.15288 32.1402 3.6192 31.7964 3.96301C31.4526 4.30683 30.9862 4.49997 30.5 4.49997H8.5C8.01377 4.49997 7.54746 4.30683 7.20364 3.96301C6.85982 3.6192 6.66667 3.15288 6.66667 2.66665C6.66667 2.18042 6.85982 1.7141 7.20364 1.37028C7.54746 1.02647 8.01377 0.833313 8.5 0.833313H30.5Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernment);
export default __webpack_public_path__ + "static/media/government.8f0b764c732c2b8983048ca767f97bc2.svg";
export { ForwardRef as ReactComponent };